const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M35.4192%2013.7243H25.7544L16.7153%2026.8622L25.6693%2040H35.502L26.3386%2026.8622L35.418%2013.975V13.9762L35.5859%2013.7243H35.4192ZM5%2026.5275H14.8327L24.1214%2013.2218L14.9166%200H5.08394L14.2887%2013.0964L13.0754%2014.8962L5%2026.5275Z'%20fill='%23E52E0E'/%3e%3c/svg%3e";
export {
  e as default
};
